module.exports = __webpack_public_path__ + "img/150.066f2dc8.jpg";